import { useState } from "react";
import Modal from "../Modal";
import Verify from "./Verify";
import { toast } from "react-toastify";
import { phoneValidate } from "../../../utils/phoneValidator";
import sendSms from "@src/api/services/sendSms";
import convertPhone from "../../../utils/convertPhone";
import { hamrahImage, irancellImage, rightelImage } from "@public/images";
import { operatorPrefixes } from "../../../constants/_operatorPrefixes";
import Image from "next/image";
import { useRouter } from "next/navigation";

const Login = ({ isOpen, handleModalToggle }) => {
  const router = useRouter();
  const [phone, setPhone] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [operatorImage, setOperatorImage] = useState(null);

  const formattedPhone = convertPhone(phone);

  const sendSmsHandler = async (e) => {
    e.preventDefault();
    const validate = phoneValidate(phone);
    if (validate) {
      try {
        await sendSms(formattedPhone);
        setIsVerified(true);
      } catch (error) {
        toast.error(error.response?.data.message || error.response?.data || "خطا در ارسال پیامک");
      }
    } else {
      toast.error("شماره موبایل نادرست است");
    }
  };

  const handleUserUpdate = () => {
    handleModalToggle();
    router.refresh();
  };

  const handleInput = (event) => {
    const value = event.target.value.replace(/[^0-9]/g, "");
    setPhone(value);

    if (value.length >= 4) {
      const prefix = value.substring(0, 4);

      if (operatorPrefixes.hamrah.includes(prefix)) {
        setOperatorImage(hamrahImage);
      } else if (operatorPrefixes.irancell.includes(prefix)) {
        setOperatorImage(irancellImage);
      } else if (operatorPrefixes.rightel.includes(prefix)) {
        setOperatorImage(rightelImage);
      } else {
        setOperatorImage(null);
      }
    } else {
      setOperatorImage(null);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      handleModalToggle={handleModalToggle}
      sizeClass="lg:w-[400px] w-[90%] h-auto p-2 pb-0"
      title={"ورود / عضویت"}
      closeOptins={true}
    >
      {isVerified ? (
        <Verify
          setIsVerified={setIsVerified}
          phone={formattedPhone}
          handleUserUpdate={handleUserUpdate}
        />
      ) : (
        <form onSubmit={sendSmsHandler} className="flex flex-col gap-11 p-8">
          <div className="flex flex-col text-right">
            <label htmlFor="phoneNumber" className="mb-2">
              شماره موبایل
            </label>
            <div className="flex h-11 w-full items-center overflow-hidden rounded-md border">
              <input
                id="phoneNumber"
                className="h-full w-full bg-transparent px-3 py-3 text-sm font-normal focus:border-gray-600 focus:outline-hidden"
                placeholder="شماره موبایل خود را وارد کنید"
                value={phone}
                onChange={handleInput}
                inputMode="numeric"
                autoComplete="off"
              />
              {operatorImage && (
                <Image
                  src={operatorImage}
                  alt="Operator"
                  className="size-12 object-contain pl-2"
                  width={48}
                  height={48}
                />
              )}
            </div>
          </div>

          <button className="bg-blue w-full cursor-pointer rounded-lg py-3 text-white">
            دریافت کد تایید
          </button>
        </form>
      )}
    </Modal>
  );
};

export default Login;
